import { Alert, Avatar, Box, Button, Chip, CircularProgress, Grid, IconButton, Stack, Switch, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { Breadcrumb, SimpleCard } from '../../components';
import React, { useCallback, useEffect, useState } from 'react';
import axios from '../../../axios';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { GET_SERVICE_LIST, REORDER_EXTRAS, REORDER_PACKAGES, RETRIEVE_SERVICE, UPDATE_SERVICE_STATUS } from '../../api';
import DeletePackage from './Modals/DeletePackages';
import DeleteExtra from './Modals/DeleteExtraModal';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import UpdateServiceModal from './Modals/UpdateService';
import CreateExtraModal from './Modals/CreateExtra';
import CreatePackageModal from './Modals/CreatePackage';
import UpdatePackageModal from './Modals/UpdatePackage';
import { baseImageUrl } from '../../utils/config';
import { DragIndicator } from '@mui/icons-material';
import DraggableDataGrid from './draggableDataGrid';
import ItemViewPackage from './Modals/ItemViewPackage';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { tenantBookingPageUrl } from '../../utils/tenantApi';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import ServiceLivePreview from './components/ServiceLivePreview';

const Container = styled('div')(({ theme }) => ({
  padding: '28px 20px 24px',
  minHeight: '100%',
  background: '#f8fafc',
  [theme.breakpoints.down('md')]: { padding: '22px 16px' },
  [theme.breakpoints.down('sm')]: { padding: '18px 12px' },
  '& .breadcrumb': {
    marginTop: '0px',
    marginBottom: '12px',
    '& > div > h4:first-of-type': {
      display: 'none',
    },
    '& > div > h4:nth-of-type(2)': {
      display: 'none',
    },
    '& .MuiBreadcrumbs-ol': {
      gap: '0px',
      alignItems: 'center',
    },
    '& a, & span': {
      fontSize: '11px',
      color: '#8a869f',
      fontWeight: 500,
      lineHeight: 1,
    },
    '& .MuiIcon-root': {
      fontSize: '17px',
      color: '#8a869f',
    },
    '& a:first-of-type .MuiIcon-root': {
      marginLeft: '0 !important',
      marginBottom: '0 !important',
      marginRight: '6px',
    },
    '& a .MuiIcon-root': {
      color: '#1976d2',
    },
    '& .MuiBreadcrumbs-separator': {
      marginLeft: '4px',
      marginRight: '4px',
    },
    '& .MuiBreadcrumbs-li:first-of-type + .MuiBreadcrumbs-separator': {
      display: 'none',
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: { marginBottom: '16px' },
  },
}));
// const DataTableBox = styled(Box)(() => ({
//   width: '100%',

//   '& .MuiDataGrid-columnHeaderTitle': {
//     fontWeight: '500',
//     fontSize: '14px',
//     color: '#0F0F0F',
//   },
//   '& .MuiDataGrid-root': {
//     borderLeft: 'none !important',
//     borderRight: 'none !important',
//     borderRadius: 'unset !important',
//     '& .MuiDataGrid-columnHeader': {
//       background: 'unset !important',
//       '&:focus': {
//         outline: 'none !important',
//       },
//       '&:focus-within': {
//         outline: 'none !important',
//       },
//     },
//     '& .MuiDataGrid-cell': {
//       '&:focus': {
//         outline: 'none !important',
//       },
//       '&:focus-within': {
//         outline: 'none !important',
//       },
//     },
//     '& .MuiDataGrid-columnSeparator': {
//       visibility: 'hidden',
//     },
//   },
// }));
const TableHeading = styled('p')(() => ({
  fontWeight: '400',
  fontSize: '14px',
  color: '#0F0F0F',
  whiteSpace: 'break-spaces',
  margin: 'unset !important',
}));
const ImageThumbWithFallback = ({ src, alt, label, width = 40, height = 40, radius = 8 }) => {
  const [imageError, setImageError] = useState(false);
  const fallbackLetter = (label || alt || 'S').toString().trim().charAt(0).toUpperCase() || 'S';
  const showImage = src && !imageError;
  const numericWidth = typeof width === 'number' ? width : 40;

  if (showImage) {
    return (
      <img
        style={{
          width,
          height,
          borderRadius: `${radius}px`,
          objectFit: 'cover',
          border: '1px solid #dbe7f5',
          display: 'block',
        }}
        src={src}
        alt={alt}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: `${radius}px`,
        border: '1px solid #dbe7f5',
        bgcolor: '#f4f8ff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Avatar
        sx={{
          width: Math.max(26, Math.min(numericWidth - 10, 64)),
          height: Math.max(26, Math.min((typeof height === 'number' ? height : 40) - 10, 64)),
          bgcolor: '#1976d2',
          color: '#fff',
          fontWeight: 700,
          fontSize: numericWidth >= 100 ? '28px' : '14px',
        }}
      >
        {fallbackLetter}
      </Avatar>
    </Box>
  );
};

function ServiceDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { slug } = useParams();
  const { state } = location;
  const [serviceData, setServiceData] = useState(null);
  const [packagesData, setPackagesData] = useState([]);
  const [extrasData, setExtrasData] = useState([]);
  const [deletePackageModal, setDeletePackageModal] = useState(false);
  const [itemPackageModal, setItemPackageModal] = useState(false);
  const [deleteExtraModal, setDeleteExtraModal] = useState(false);
  const [selectedPackage, setselectedPackage] = useState({});
  const [selectedExtra, setSelectedExtra] = useState(null);
  const [serviceStatus, setserviceStatus] = useState(false);
  const [updateServiceDataModal, setUpdateServiceDataModal] = useState(false);
  const [createExtraModal, setCreateExtraModal] = useState(false);
  const [createPackageModal, setCreatePackageModal] = useState(false);
  const [updatePackageModal, setUpdatePackageModal] = useState(false);
  const [selectedPackageData, setSelectedPackageData] = useState({});
  const [activeTab, setActiveTab] = useState('packages');
  const [packagesPaginationModel, setPackagesPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [extrasPaginationModel, setExtrasPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [detailsError, setDetailsError] = useState('');

  const retrieveService = useCallback(async () => {
    setDetailsError('');
    setServiceData(null);
    try {
      let serviceId = state?.id;
      if (!serviceId && slug) {
        const listResponse = await axios.get(GET_SERVICE_LIST, {
          headers: { 'Content-Type': 'application/json' },
        });
        serviceId = (listResponse?.data?.data || []).find((service) => service?.slug === slug)?.id;
      }
      if (!serviceId) {
        setDetailsError('Service details were not found.');
        return;
      }

      await axios
      .get(`${RETRIEVE_SERVICE}/${serviceId}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((res) => {
        const data = res?.data?.data;
        if (!data) {
          setDetailsError('Service details were not found.');
          return;
        }
        setServiceData(data);
        const packageSorted = (data?.packages || []).slice().sort((a, b) => a.order - b.order);
        setPackagesData(packageSorted);
        setSelectedPackageData((prev) => {
          if (!prev?.id) return prev;
          return packageSorted?.find((z) => z?.id === prev?.id) || prev;
        });
        const extraSorted = (data?.extras || []).slice().sort((a, b) => a.order - b.order);
        setExtrasData(extraSorted);
        if (res?.data?.data?.status === 'Draft') {
          setserviceStatus(false);
        } else {
          setserviceStatus(true);
        }
      });
    } catch (error) {
      setDetailsError('Service details could not be loaded.');
    }
  }, [slug, state?.id]);
  useEffect(() => {
    retrieveService();
  }, [retrieveService]);

  // const changeOrder = (current, direction) => {
  //   const newArr = packagesData.slice();
  //   const index = newArr.findIndex(obj => obj.order === current);
  //   const index2 = direction === 'next' ? index + 1 : index - 1;
  //   if (
  //     index < 0 ||
  //     index >= newArr.length ||
  //     index2 < 0 ||
  //     index2 >= newArr.length ||
  //     index === index2
  //   ) {
  //     console.error("Invalid indices provided.");
  //   } else {
  //     [newArr[index], newArr[index2]] = [newArr[index2], newArr[index]];
  //     [newArr[index].order, newArr[index2].order] = [newArr[index2].order, newArr[index].order];
  //     setPackagesData(newArr);
  //   }
  // };
  // const changeOrderExtras = (current, direction) => {
  //   const newArr = extrasData.slice();
  //   const index = newArr.findIndex(obj => obj.order === current);
  //   const index2 = direction === 'next' ? index + 1 : index - 1;
  //   if (
  //     index < 0 ||
  //     index >= newArr.length ||
  //     index2 < 0 ||
  //     index2 >= newArr.length ||
  //     index === index2
  //   ) {
  //     console.error("Invalid indices provided.");
  //   } else {
  //     [newArr[index], newArr[index2]] = [newArr[index2], newArr[index]];
  //     [newArr[index].order, newArr[index2].order] = [newArr[index2].order, newArr[index].order];
  //     setExtrasData(newArr);
  //   }
  // };
  const packages = [
    {
      field: 'title',
      headerName: 'Package',
      width: '50%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box>
              <ImageThumbWithFallback
                width={40}
                height={40}
                radius={6}
                src={baseImageUrl + item?.row?.image_12pack}
                alt="img"
                label={item?.value}
              />
            </Box>
            <Box>
              <TableHeading style={{ fontWeight: 'bold' }}>{item?.value}</TableHeading>
              <TableHeading>{item?.row?.item?.length} order ongoing</TableHeading>
              <TableHeading>{item?.row?.item?.length} items</TableHeading>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'item',
      headerName: 'Items',
      width: '15%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box
            sx={{
              color: '#206bc4',
              fontWeight: '400',
              fontSize: '14px',
              whiteSpace: 'break-spaces',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={() => {
              setselectedPackage(item?.row);
              setItemPackageModal(true);
            }}
          >
            View
          </Box>
        );
      },
    },
    {
      field: 'order',
      headerName: 'Order',
      width: '15%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box
            sx={{
              paddingLeft: '3px',
              display: 'flex',
              alignItems: 'center',
              lineHeight: '14px',
              cursor: 'grab',
            }}
          >
            {item.row?.order}
            <DragIndicator fontSize="small" />
            {/* <ArrowUpward onClick={() => changeOrder(item.row.order, 'prev')}/>
            <ArrowDownward onClick={() => changeOrder(item.row.order, 'next')}/> */}
          </Box>
        );
      },
    },
    {
      field: '',
      headerName: 'Actions',
      width: '20%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <Tooltip title="Edit package">
            <IconButton
              aria-label={`Edit ${item?.row?.title || 'package'}`}
              sx={{ width: 38, height: 38, border: '1px solid #e1e7f0', borderRadius: '8px', color: '#52647f', '&:hover': { bgcolor: '#eef5ff', color: '#1468df' } }}
              onClick={() => {
                setSelectedPackageData(item?.row);
                setUpdatePackageModal(true);
              }}
            >
              <EditOutlinedIcon sx={{ fontSize: 19 }} />
            </IconButton>
            </Tooltip>
            <Tooltip title="Delete package">
            <IconButton
              aria-label={`Delete ${item?.row?.title || 'package'}`}
              sx={{ width: 38, height: 38, border: '1px solid #e1e7f0', borderRadius: '8px', color: '#f04452', '&:hover': { bgcolor: '#fff1f2', borderColor: '#fecdd3' } }}
              onClick={() => {
                setselectedPackage(item?.row);
                setDeletePackageModal(true);
              }}
            >
              <DeleteOutlineOutlinedIcon sx={{ fontSize: 19 }} />
            </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  const extras = [
    {
      field: 'title',
      headerName: 'Extra',
      flex: 1,
      width: '65%',
      sortable: false,
      renderCell: (item) => {
        // return <TableHeading>{item?.value}</TableHeading>;
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box>
              <ImageThumbWithFallback
                width={40}
                height={40}
                radius={6}
                src={baseImageUrl + item?.row?.image_12}
                alt="img"
                label={item?.value}
              />
            </Box>
            <Box>
              <TableHeading style={{ fontWeight: 'bold' }}>{item?.value}</TableHeading>
              <TableHeading>Time Hrs: {item?.row?.time_hrs}</TableHeading>
              <TableHeading>Cost: {item?.row?.price}</TableHeading>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'order',
      headerName: 'Order',
      flex: 1,
      width: '15%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box
            sx={{
              paddingLeft: '3px',
              display: 'flex',
              alignItems: 'center',
              lineHeight: '14px',
              cursor: 'grab',
            }}
          >
            {item.row?.order}
            <DragIndicator fontSize="small" />
            {/* <ArrowUpward onClick={() => changeOrderExtras(item.row.order, 'prev')}/>
            <ArrowDownward onClick={() => changeOrderExtras(item.row.order, 'next')}/> */}
          </Box>
        );
      },
    },
    {
      field: '',
      headerName: 'Actions',
      flex: 1,
      width: '20%',
      sortable: false,
      renderCell: (item) => {
        return (
          <Box display={'flex'} alignItems="center" gap={0.8}>
            <Tooltip title="Edit extra">
            <IconButton
              aria-label={`Edit ${item?.row?.title || 'extra'}`}
              sx={{ width: 38, height: 38, border: '1px solid #e1e7f0', borderRadius: '8px', color: '#52647f', '&:hover': { bgcolor: '#eef5ff', color: '#1468df' } }}
              onClick={() => {
                setSelectedExtra(item?.row);
                setCreateExtraModal(true);
              }}
            >
              <EditOutlinedIcon sx={{ fontSize: 19 }} />
            </IconButton>
            </Tooltip>
            <Tooltip title="Delete extra">
            <IconButton
              aria-label={`Delete ${item?.row?.title || 'extra'}`}
              sx={{ width: 38, height: 38, border: '1px solid #e1e7f0', borderRadius: '8px', color: '#f04452', '&:hover': { bgcolor: '#fff1f2', borderColor: '#fecdd3' } }}
              onClick={() => {
                setSelectedExtra(item?.row);
                setDeleteExtraModal(true);
              }}
            >
              <DeleteOutlineOutlinedIcon sx={{ fontSize: 19 }} />
            </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  const handleStatusChange = (event) => {
    const data = {
      id: serviceData?.id,
      status: event.target.checked ? 'published' : 'Draft',
    };
    setserviceStatus(event.target.checked);

    toast.promise(
      axios.put(`${UPDATE_SERVICE_STATUS}`, data, {
        headers: { 'Content-Type': 'application/json' },
      }),
      {
        loading: () => {
          return `Updating Status!`;
        },
        success: (res) => {
          retrieveService();

          return res?.data?.message;
        },
        error: (err) => {
          setserviceStatus(!event.target.checked);
          return err?.message;
        },
      }
    );
  };
  const handlePackagesOrder = (data) => {
    if (data?.length) {
      const formattedList = data.map((z) => {
        return {
          package_id: z?.id,
          order: z?.order,
        };
      });
      toast.promise(
        axios.put(`${REORDER_PACKAGES}/${state?.id}/`, formattedList, {
          headers: { 'Content-Type': 'application/json' },
        }),
        {
          loading: () => {
            return `Updating Order!`;
          },
          success: (res) => {
            return res?.data?.message;
          },
          error: (err) => {
            return err?.message;
          },
        }
      );
    }
  };
  const handleExtrasOrder = (data) => {
    if (data?.length) {
      const formattedList = data.map((z) => {
        return {
          extra_id: z?.id,
          order: z?.order,
        };
      });
      toast.promise(
        axios.put(`${REORDER_EXTRAS}/${state?.id}/`, formattedList, {
          headers: { 'Content-Type': 'application/json' },
        }),
        {
          loading: () => {
            return `Updating Order!`;
          },
          success: (res) => {
            return res?.data?.message;
          },
          error: (err) => {
            return err?.message;
          },
        }
      );
    }
  };
  return (
    <Container>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} sx={{ mb: 1.5, gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.2 }}>
          <Box sx={{ width: 42, height: 42, display: 'grid', placeItems: 'center', borderRadius: 2.5, bgcolor: '#e8f3ff', color: '#1976d2' }}><DriveFileRenameOutlineIcon /></Box>
          <Box>
          <Typography sx={{ fontSize: { xs: 22, md: 25 }, fontWeight: 850, color: '#10224a', lineHeight: 1.15 }}>
            Edit Service
          </Typography>
          <Box className="breadcrumb">
            <Breadcrumb
              routeSegments={[{ name: 'Services', path: '/dashboard/services' }, { name: serviceData?.title || 'Edit Service' }]}
            />
          </Box>
          </Box>
        </Box>
        <Button variant="outlined" startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate('/dashboard/services')} sx={{ minHeight: 39, borderRadius: 2, textTransform: 'none', fontWeight: 750 }}>Back to Services</Button>
      </Stack>
      {detailsError && (
        <Alert
          severity="error"
          action={
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Button color="inherit" size="small" onClick={retrieveService}>Retry</Button>
              <Button color="inherit" size="small" onClick={() => navigate('/dashboard/services')}>Back</Button>
            </Box>
          }
          sx={{ mb: 2 }}
        >
          {detailsError}
        </Alert>
      )}
      {!serviceData && !detailsError && <Box sx={{ minHeight: 320, display: 'grid', placeItems: 'center' }}><Box sx={{ textAlign: 'center' }}><CircularProgress size={30} /><Typography sx={{ mt: 1, color: '#718096', fontSize: 12 }}>Loading service details...</Typography></Box></Box>}
      {serviceData && <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} lg={7.25}>
          <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <SimpleCard
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '13px',
              overflow: 'hidden',
              padding: '20px !important',
              height: '100%',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}><Box sx={{ width: 35, height: 35, display: 'grid', placeItems: 'center', borderRadius: 2, bgcolor: '#edf5ff', color: '#1976d2' }}><InfoOutlinedIcon fontSize="small" /></Box><Box sx={{ flex: 1 }}><Typography sx={{ color: '#10224a', fontSize: 15, fontWeight: 850 }}>Basic Information</Typography><Typography sx={{ color: '#718096', fontSize: 10.5 }}>Main details shown to customers.</Typography></Box><Button size="small" startIcon={<EditOutlinedIcon />} onClick={() => setUpdateServiceDataModal(true)} sx={{ textTransform: 'none', fontWeight: 750 }}>Edit</Button></Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.2 }}>
              {[['Service name', serviceData.name], ['Customer title', serviceData.title], ['Service URL', serviceData.slug], ['Type', serviceData.type]].map(([label, value]) => <Box key={label} sx={{ p: 1.2, borderRadius: 2, bgcolor: '#f8fbff', border: '1px solid #e7eef6' }}><Typography sx={{ color: '#7a879b', fontSize: 9.5, fontWeight: 750, textTransform: 'uppercase' }}>{label}</Typography><Typography noWrap sx={{ mt: .35, color: '#183153', fontSize: 12, fontWeight: 700 }}>{value || '—'}</Typography></Box>)}
            </Box>
            <Box sx={{ mt: 1.2, p: 1.2, borderRadius: 2, bgcolor: '#f8fbff', border: '1px solid #e7eef6' }}><Typography sx={{ color: '#7a879b', fontSize: 9.5, fontWeight: 750, textTransform: 'uppercase' }}>Description</Typography><Typography sx={{ mt: .35, color: '#53627a', fontSize: 11.5, lineHeight: 1.55 }}>{serviceData.description || 'No description provided.'}</Typography></Box>
            <Box sx={{ mt: 1.2, display: 'flex', alignItems: 'center', gap: 1 }}><Typography sx={{ color: '#718096', fontSize: 10.5 }}>Brand color</Typography><Box sx={{ width: 23, height: 23, borderRadius: 1, bgcolor: serviceData.colour || '#1976d2', border: '2px solid #fff', boxShadow: '0 0 0 1px #cbd5e1' }} /><Typography sx={{ color: '#183153', fontSize: 11, fontWeight: 700 }}>{serviceData.colour || '—'}</Typography></Box>
          </SimpleCard>
        </Grid>
        <Grid item xs={12} md={5}>
          <SimpleCard sx={{ border: '1px solid #e2e8f0', borderRadius: '13px', overflow: 'hidden', padding: '20px !important', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}><Box sx={{ width: 35, height: 35, display: 'grid', placeItems: 'center', borderRadius: 2, bgcolor: '#edf5ff', color: '#1976d2' }}><ImageRoundedIcon fontSize="small" /></Box><Box><Typography sx={{ color: '#10224a', fontSize: 15, fontWeight: 850 }}>Service Media</Typography><Typography sx={{ color: '#718096', fontSize: 10.5 }}>Primary and secondary images.</Typography></Box></Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1 }}>
              <Box><Typography sx={{ mb: .6, color: '#718096', fontSize: 9.5, fontWeight: 750 }}>PRIMARY IMAGE</Typography><ImageThumbWithFallback width="100%" height={115} radius={10} src={baseImageUrl + serviceData.image_1} alt="Primary service" label={serviceData.slug} /></Box>
              <Box><Typography sx={{ mb: .6, color: '#718096', fontSize: 9.5, fontWeight: 750 }}>SECONDARY IMAGE</Typography><ImageThumbWithFallback width="100%" height={115} radius={10} src={baseImageUrl + serviceData.image_2} alt="Secondary service" label={serviceData.slug} /></Box>
            </Box>
            <Box sx={{ mt: 1.5, p: 1.1, display: 'flex', alignItems: 'center', gap: 1, borderRadius: 2, bgcolor: '#f8fbff', border: '1px solid #e7eef6' }}><Switch size="small" checked={serviceStatus} onChange={handleStatusChange} inputProps={{ 'aria-label': 'Publish service' }} /><Box sx={{ flex: 1 }}><Typography sx={{ color: '#183153', fontSize: 11.5, fontWeight: 800 }}>Published</Typography><Typography sx={{ color: '#718096', fontSize: 9.5 }}>Available on the booking page.</Typography></Box><Chip size="small" label={serviceData.status || 'Draft'} color={serviceStatus ? 'success' : 'default'} sx={{ height: 22, fontSize: 9.5, fontWeight: 750 }} /></Box>
            <Button component="a" href={tenantBookingPageUrl(serviceData.slug)} fullWidth variant="outlined" startIcon={<OpenInNewRoundedIcon />} sx={{ mt: 1.2, borderRadius: 2, textTransform: 'none', fontWeight: 750 }}>Open customer page</Button>
          </SimpleCard>
        </Grid>
        <Grid item xs={12}>
          <SimpleCard
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '13px',
              overflow: 'hidden',
              padding: '20px !important',
            }}
          >
            <Box sx={{ px: 0, pt: 0, pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 35, height: 35, display: 'grid', placeItems: 'center', borderRadius: 2, bgcolor: '#edf5ff', color: '#1976d2' }}><Inventory2OutlinedIcon fontSize="small" /></Box><Box sx={{ flex: 1 }}><Typography sx={{ color: '#10224a', fontSize: 15, fontWeight: 850 }}>Packages & Extras</Typography><Typography sx={{ color: '#718096', fontSize: 10.5 }}>Drag to reorder and use the existing actions to manage content.</Typography></Box><Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => { if (activeTab === 'packages') { setCreatePackageModal(true); setselectedPackage({}); } else { setCreateExtraModal(true); setSelectedExtra(null); } }} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 750 }}>Add {activeTab === 'packages' ? 'Package' : 'Extra'}</Button></Box>
            <Tabs
              value={activeTab}
              onChange={(e, value) => setActiveTab(value)}
              sx={{
                px: 0,
                minHeight: 40,
                borderBottom: '1px solid #e2e8f0',
                '& .MuiTab-root': {
                  minHeight: 40,
                  textTransform: 'none',
                  fontSize: '13px',
                  fontWeight: 600,
                  color: '#6f6a63',
                },
                '& .Mui-selected': {
                  color: '#1976d2 !important',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#1976d2',
                  height: '2px',
                },
              }}
            >
              <Tab label="Packages" value="packages" />
              <Tab label="Extras" value="extras" />
            </Tabs>
            <Box sx={{ pt: 1.5 }}>
              <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', '& [role="columnheader"]': { bgcolor: '#f8faff' }, '& [role="columnheader"] *': { fontSize: '11px', fontWeight: 700, color: '#53627a', letterSpacing: '0.05em', textTransform: 'uppercase' }, '& [role="row"]': { borderColor: '#edf1f6' } }}>
                {activeTab === 'packages' ? (
                  <DraggableDataGrid
                    data={packagesData}
                    columns={packages}
                    onListUpdate={handlePackagesOrder}
                    pagination
                    paginationModel={packagesPaginationModel}
                    onPaginationModelChange={setPackagesPaginationModel}
                  />
                ) : (
                  <DraggableDataGrid
                    data={extrasData}
                    columns={extras}
                    onListUpdate={handleExtrasOrder}
                    pagination
                    paginationModel={extrasPaginationModel}
                    onPaginationModelChange={setExtrasPaginationModel}
                  />
                )}
              </Box>
            </Box>
          </SimpleCard>
        </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4.75}>
          <Box sx={{ position: { lg: 'sticky' }, top: { lg: 14 } }}><ServiceLivePreview service={serviceData} packages={packagesData} extras={extrasData} /></Box>
        </Grid>
      </Grid>}

      <Toaster position="top-right" />
      <DeletePackage
        open={deletePackageModal}
        handleClose={() => setDeletePackageModal(false)}
        id={selectedPackage?.id}
        retrieveService={retrieveService}
      />
      <ItemViewPackage
        open={itemPackageModal}
        handleClose={() => setItemPackageModal(false)}
        data={selectedPackage}
        getServicesData={retrieveService}
      />
      <DeleteExtra
        open={deleteExtraModal}
        handleClose={() => setDeleteExtraModal(false)}
        id={selectedExtra?.id}
        retrieveService={retrieveService}
      />
      <UpdateServiceModal
        open={updateServiceDataModal}
        handleClose={() => setUpdateServiceDataModal(false)}
        serviceData={serviceData}
        retrieveService={retrieveService}
      />
      <CreateExtraModal
        open={createExtraModal}
        handleClose={() => setCreateExtraModal(false)}
        serviceData={serviceData}
        retrieveService={retrieveService}
        selectedExtra={selectedExtra}
      />
      <CreatePackageModal
        open={createPackageModal}
        handleClosePackage={() => setCreatePackageModal(false)}
        serviceData={serviceData}
        retrieveService={retrieveService}
      />
      <UpdatePackageModal
        open={updatePackageModal}
        handleClosePackage={() => setUpdatePackageModal(false)}
        serviceData={serviceData}
        retrieveService={retrieveService}
        selectedPackageData={selectedPackageData}
      />
    </Container>
  );
}

export default ServiceDetails;
